import { LOGO_URL } from "@/lib/catalog";

export default function Brand({ size = "md", showTagline = true, className = "" }) {
  const dim = size === "lg" ? "w-24 h-24" : size === "sm" ? "w-10 h-10" : "w-14 h-14";
  const title = size === "lg" ? "text-4xl" : size === "sm" ? "text-base" : "text-2xl";
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="brand-mark">
      <img src={LOGO_URL} alt="Face Club" className={`${dim} rounded-full object-contain`} draggable={false} />
      <div className="leading-tight">
        <div className={`font-display font-extrabold tracking-tight ${title}`}>
          Face <span className="gold-text">Club</span>
        </div>
        {showTagline && (
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.3em] text-amber-500/70 font-semibold">
            Karya Tanpa Sempadan
          </div>
        )}
      </div>
    </div>
  );
}
